import React from 'react'

const PlayIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_15313_182648)">
                <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A3A3A3" />
                <path d="M8 6V18L17 12L8 6Z" fill="#A3A3A3" />
            </g>
            <defs>
                <clipPath id="clip0_15313_182648">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PlayIcon